import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, Collapse, List, ListItemText, Typography } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import DASHBOARD_ICON from '../../assets/images/drawer_icons/dashboard_icon.svg';
import order_ic from '../../assets/images/dashboard/order_ic.svg';
import customer_ic from '../../assets/images/dashboard/ic_user.svg';
import admin_ic from '../../assets/images/dashboard/admin_ic.svg';
import product_ic from '../../assets/images/drawer_icons/product.svg';
import category_ic from '../../assets/images/drawer_icons/category_management.svg';
import jiffy_merchant_ic from '../../assets/images/drawer_icons/jiffy_merchant.svg';
import nested_list_item_ic from '../../assets/images/drawer_icons/nested_list_item.svg';
import driver_ic from '../../assets/images/drawer_icons/driver.svg';
import advertisement_ic from '../../assets/images/drawer_icons/advertisment.svg';
import coupon_ic from '../../assets/images/drawer_icons/coupon.svg';
import report_ic from '../../assets/images/dashboard/report_ic.svg'
import { useState } from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { CATEGORIES_ROUTE, DASHBOARD_ROUTE, INVOICE, MERCHANT_DETAIL, MERCHANT_USER_ROUTE, ORDER_ROUTE, PRODUCT_ROUTE, RETURN_ORDER_ROUTE, SALES_REPORT_ROUTE } from '../../routes/paths';
import MY_ORDER_ICON from '../../assets/images/drawer_icons/my_order.svg';
import SALES_REPORT_ICON from '../../assets/images/drawer_icons/sales_report_icon.svg';
import PRODUCT_ICON from '../../assets/images/drawer_icons/product.svg';
import CATEGORY_MANAGEMENT_ICON from '../../assets/images/drawer_icons/category_management.svg';
import MERCHANT_USER_ICON from '../../assets/images/drawer_icons/merchant_user_icon.svg';
import { checkPermission } from '../../utils/checkPermission';
import { MerchantUserModel } from '../../models/merchantUser';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
// ----------------------------------------------------------------------

interface Props {
  title: string;
  path: string;
  icon: JSX.Element;
}

interface NestedItemProps {
  nestedValue: string;
  iconSrc: string;
  listItems: JSX.Element[]
}

interface IconImageProps {
  imageUrl: string,
  width?: string,
  height?: string
}

const IconImage = ({ imageUrl, height = "24px", width = "24px" }: IconImageProps) => {
  return <img src={imageUrl} alt="" style={{
    width,
    height
  }} />
}

const IconNestedListItemImage = ({ imageUrl, height = "7px", width = "7px" }: IconImageProps) => {
  return <img src={imageUrl} alt="" style={{
    width,
    height
  }} />
}

export default function NavSection({ data = [], ...other }: any) {
  const authData: MerchantUserModel = useSelector((state: RootState) => state?.auth?.data ?? null!);
  const [currentNestedList, setCurrentNestedList] = useState<string>("");

  const handleClickNestedListItem = (value: string) => {
    setCurrentNestedList(currentNestedList && value === currentNestedList ? "" : value);
  }

  const NestedListItem = ({ nestedValue, iconSrc, listItems }: NestedItemProps) => {
    return <>
      <StyledNavItem onClick={() => handleClickNestedListItem(nestedValue)}>
        <StyledNavItemIcon>
          <IconImage imageUrl={iconSrc} />
        </StyledNavItemIcon>
        <ListItemText disableTypography primary={nestedValue} />
        {currentNestedList === nestedValue ? <ExpandLess /> : <ExpandMore />}
      </StyledNavItem>
      <Collapse in={currentNestedList === nestedValue} timeout="auto" unmountOnExit>
        <List disablePadding sx={{
          paddingLeft: 2,
          paddingTop: 1,
          paddingRight: 1,
          paddingBottom: 1
        }}>
          {
            listItems?.map((item) => {
              return item;
            })
          }
        </List>
      </Collapse>
    </>
  }

  const { t } = useTranslation("global");
  return (
    <Box {...other}>
      <Box sx={{ height: 'calc(100vh - 180px)', overflow: 'auto' }}>
        <List disablePadding sx={{ p: 1, paddingBottom: 10 }}>
          <NavItem title={t("drawer_component.Dashboard")} path={DASHBOARD_ROUTE} icon={<IconImage imageUrl={DASHBOARD_ICON} />} />
          {/* <NavItem title={"Invoice"} path={INVOICE} icon={<IconImage imageUrl={DASHBOARD_ICON} />} /> */}
          <NavItem title={t("drawer_component.My Order")} path={ORDER_ROUTE} icon={<IconImage imageUrl={MY_ORDER_ICON} />} />
          <NavItem title={t("drawer_component.Return Order")} path={RETURN_ORDER_ROUTE} icon={<IconImage imageUrl={MY_ORDER_ICON} />} />
          {
            checkPermission(authData?.role?.role_type, SALES_REPORT_ROUTE)
            &&
            <NavItem title={t("drawer_component.Sales Report")} path={SALES_REPORT_ROUTE} icon={<IconImage imageUrl={SALES_REPORT_ICON} />} />
          }
          <NavItem title={t("drawer_component.Product")} path={PRODUCT_ROUTE} icon={<IconImage imageUrl={PRODUCT_ICON} />} />
          <NavItem title={t("drawer_component.Categories")} path={CATEGORIES_ROUTE} icon={<IconImage imageUrl={CATEGORY_MANAGEMENT_ICON} />} />
          {
            checkPermission(authData?.role?.role_type, MERCHANT_USER_ROUTE)
            &&
            <NavItem title={t("drawer_component.Staff")} path={MERCHANT_USER_ROUTE} icon={<IconImage imageUrl={MERCHANT_USER_ICON} />} />

          }
          {checkPermission(authData?.role?.role_type, MERCHANT_DETAIL)
            &&
            <NavItem title={t("drawer_component.Merchant Detail")} path={MERCHANT_DETAIL} icon={<IconImage imageUrl={MERCHANT_USER_ICON} />} />

          }

        </List>
      </Box>
    </Box>
  );
}

// ----------------------------------------------------------------------

const NavItem = ({ title, path, icon }: Props) => {
  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

    </StyledNavItem>
  );
}
